import { render } from "./Table.vue?vue&type=template&id=5f6c2608&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=5f6c2608&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6c2608"],['__file',"src/assets/js/components/Table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f6c2608"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f6c2608', __exports__)) {
    api.reload('5f6c2608', __exports__)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=5f6c2608&scoped=true", () => {
    api.rerender('5f6c2608', render)
  })

}


export default __exports__